import React, { useState, useEffect, useRef } from 'react';

interface Word {
    word: string;
    start: number;
}

const wordTimings: Word[] = [
    { word: "To Λιοντάρι", start: 0.01 },
    { word: "της Νεμέας", start: 0.02 },
    { word: "O Ηρακλής", start: 0.03 },
    { word: "παίρνει", start: 0.04 },
    { word: "μήνυμα", start: 0.05 },
    { word: "από τον θεό Απόλλωνα,", start: 0.06 },
    { word: "Φεύγει", start: 0.07 },
    { word: "για την Πελοπόννησο.", start: 0.08 },
    { word: "Πηγαίνει", start: 0.09 },
    { word: "στις Μυκήνες.", start: 0.10 },
    { word: "Εκεί", start: 0.11 },
    { word: "ο Βασιλιάς Ευρυσθέας", start: 0.12 },
    { word: "δίνει", start: 0.14 },
    { word: "έναν άθλο στον Ηρακλή:", start: 0.15 },
    { word: "Πρέπει", start: 0.16 },
    { word: "το λιοντάρι", start: 0.17 },
    { word: "της Νεμέας.", start: 0.18 },
    { word: "να σκοτώσει", start: 0.19 },
    { word: "Η Νεμέα", start: 0.20 },
    { word: "είναι κοντά", start: 0.21 },
    { word: "στις Μυκήνες.", start: 0.22 },
    { word: "Ο τόπος", start: 0.23 },
    { word: "είναι ένα όνειρο!", start: 0.24 },
    { word: "Έχει όμορφα", start: 0.26 },
    { word: "βουνά", start: 0.27 },
    { word: "με δέντρα και", start: 0.28 },
    { word: "πολλά άγρια ζώα.", start: 0.29 },
    { word: "Το άγριο λιοντάρι", start: 0.31 },
    { word: "όμως", start: 0.32 },
    { word: "τρομοκρατεί", start: 0.33 },
    { word: "την πόλη.", start: 0.34 },
    { word: "Τρώει ζώα", start: 0.35 },
    { word: "και ανθρώπους.", start: 0.36 },
    { word: "Ο Ηρακλής", start: 0.38 },
    { word: "πάει στο βουνό.", start: 0.39 },
    { word: "Βλέπει τα δέντρα", start: 0.40 },
    { word: "και τον ουρανό.", start: 0.42 },
    { word: "Βλέπει πηγές", start: 0.43 },
    { word: "και σπηλιές.", start: 0.44 },
    { word: "Βλέπει", start: 0.45 },
    { word: "λύκους,", start: 0.46 },
    { word: "αλεπούδες", start: 0.47 },
    { word: "και τσακάλια.", start: 0.48 },
    { word: "Ψάχνει το λιοντάρι.", start: 0.49 },
    { word: "Πολλές", start: 0.51 },
    { word: "μέρες", start: 0.52 },
    { word: "και νύχτες", start: 0.53 },
    { word: "περπατάει", start: 0.54 },
    { word: "και κοιτάζει.", start: 0.55 },
    { word: "Κρατάει", start: 0.56 },
    { word: "ένα ρόπαλο.", start: 0.57 },
    { word: "Ψάχνει", start: 0.58 },
    { word: "παντού", start: 0.59 },
    { word: "και περιμένει.", start: 1.00 },
    { word: "Ξαφνικά,", start: 1.01 },
    { word: "το λιοντάρι", start: 1.03 },
    { word: "πλησιάζει", start: 1.04 },
    { word: "τον Ηρακλή.", start: 1.05 },
    { word: "Είναι", start: 1.06 },
    { word: "τεράστιο!", start: 1.07 },
    { word: "Ήρθε η ώρα!", start: 1.08 },
    { word: "Ο Ηρακλής το", start: 1.10 },
    { word: "σημαδεύει.", start: 1.11 },
    { word: "Παίρνει", start: 1.12 },
    { word: "το ρόπαλο", start: 1.13 },
    { word: "και το χτυπάει.", start: 1.14 },
    { word: "Το λιοντάρι", start: 1.15 },
    { word: "μπαίνει στη σπηλιά του.", start: 1.16 },
    { word: "Ο Ηρακλής", start: 1.18 },
    { word: "Παλεύει", start: 1.20 },
    { word: "με το λιοντάρι.", start: 1.21 },
    { word: "Με τα χέρια του", start: 1.22 },
    { word: "γρήγορα", start: 1.23 },
    { word: "το σκοτώνει.", start: 1.24 },
    { word: "Παίρνει", start: 1.25 },
    { word: "το δέρμα", start: 1.26 },
    { word: "του λιονταριού", start: 1.27 },
    { word: "και το φοράει.", start: 1.28 },
    { word: "Πηγαίνει", start: 1.29 },
    { word: "στον Βασιλιά Ευρυσθέα.", start: 1.30 },
    { word: "Ο Ευρυσθέας", start: 1.32 },
    { word: "βλέπει", start: 1.33 },
    { word: "τον Ηρακλή", start: 1.34 },
    { word: "με τη λεοντή!", start: 1.35 },
    { word: "Τρομάζει", start: 1.37 },
    { word: "και μπαίνει", start: 1.38 },
    { word: "σε ένα πιθάρι!", start: 1.39 }
];

const GreekTextDisplay1: React.FC = () => {
    const [currentWordIndex, setCurrentWordIndex] = useState<number>(-1);
    const [isPlaying, setIsPlaying] = useState<boolean>(false);
    const [globalOffset, setGlobalOffset] = useState(0);
    const audioRef = useRef<HTMLAudioElement | null>(null);

    useEffect(() => {
        audioRef.current = new Audio('/labor1Recording.m4a');
        audioRef.current.addEventListener('ended', () => {
            setIsPlaying(false);
            setCurrentWordIndex(-1);
        });
        return () => {
            if (audioRef.current) {
                audioRef.current.removeEventListener('ended', () => {
                    setIsPlaying(false);
                    setCurrentWordIndex(-1);
                });
                audioRef.current.pause();
            }
        };
    }, []);

    useEffect(() => {
        if (!audioRef.current) return;

        let animationFrameId: number;

        const updateHighlight = () => {
            if (!audioRef.current || !isPlaying) return;

            const currentTime = audioRef.current.currentTime;
            const adjustedTime = currentTime + globalOffset;

            const newIndex = wordTimings.findIndex((word, index) =>
                index === wordTimings.length - 1 || adjustedTime < convertTimeToSeconds(wordTimings[index + 1].start)
            );

            if (newIndex !== currentWordIndex) {
                setCurrentWordIndex(newIndex);
            }

            animationFrameId = requestAnimationFrame(updateHighlight);
        };

        if (isPlaying) {
            animationFrameId = requestAnimationFrame(updateHighlight);
        }

        return () => {
            cancelAnimationFrame(animationFrameId);
        };
    }, [isPlaying, currentWordIndex, globalOffset]);

    const convertTimeToSeconds = (time: number): number => {
        const minutes = Math.floor(time);
        const seconds = (time - minutes) * 100;
        return minutes * 60 + seconds;
    };

    const togglePlay = () => {
        if (isPlaying) {
            audioRef.current?.pause();
        } else {
            audioRef.current?.play();
        }
        setIsPlaying(!isPlaying);
    };

    return (
        <div className="p-4">
            <div className="mb-4 flex items-center space-x-2">
                <button
                    onClick={togglePlay}
                    className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
                >
                    {isPlaying ? 'Pause' : 'Play'}
                </button>
                <button
                    onClick={() => setGlobalOffset(prev => Math.max(prev - 0.1, -5))}
                    className="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded"
                >
                    Advance Highlight
                </button>
                <button
                    onClick={() => setGlobalOffset(prev => Math.min(prev + 0.1, 5))}
                    className="bg-yellow-500 hover:bg-yellow-700 text-white font-bold py-2 px-4 rounded"
                >
                    Delay Highlight
                </button>
                <span>Current Offset: {globalOffset.toFixed(1)}s</span>
            </div>
            <div>
                Audio Time: {audioRef.current?.currentTime.toFixed(2)}s
                Expected Word: {wordTimings[currentWordIndex]?.word}
                Expected Time: {wordTimings[currentWordIndex]?.start}s
            </div>
            <div className="bg-gray-100 p-6 rounded-lg shadow-md">
                {wordTimings.map((wordTiming, index) => (
                    <span
                        key={index}
                        className={`inline-block p-1 rounded ${index === currentWordIndex ? 'bg-yellow-200' : ''
                            }`}
                    >
                        {wordTiming.word}{' '}
                    </span>
                ))}
            </div>
        </div>
    );
};

export default GreekTextDisplay1;